import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';

@Component({
  selector: 'app-table-widget-font-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class FontIconComponent extends WidgetComponent implements OnInit {

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  public getContent() {
    if (!this._content) {
      if (this.tableColumn.checkerValue) {
        this._content = this.tableColumn.checkerValue(this.tableElement.getData());
      } else {
        this._content = super.getContent();
      }  
    }
    return this._content;

  }

  ngOnInit() {
  }
}
